import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const schema = (t: TFunction) => () =>
  Yup.object().shape(
    {
      SiteName: Yup.string().required(t('global.requiredField'))
    }
  )
